import { createReducer } from '@reduxjs/toolkit';

import * as imageActions from './imageActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  uid: 0,
  type: 'image',
  isActive: false,

  aspectRatio: 'original',
  img: '',
  isFullWidth: false,
  url: '',
  // What the reader sees while images are blocked, and where the picture sits in the column.
  alt: '',
  align: 'center',
};

const image = createReducer(initialState, (builder) => {
  builder
    .addCase(imageActions.imageUpdateId, (state, { payload: id }) => ({ ...state, id }))
    .addCase(imageActions.imageUpdateIsActive, (state, { payload: isActive }) => ({ ...state, isActive }))

    .addCase(imageActions.imageStore, (state, { payload: data }) => {
      const {
        blockId,
        uid,
        isActive,

        image,
      } = data;

      const section = image ?? {};
      const { aspectRatio, image: img, isFullWidth, url, alt, align } = section;

      return {
        ...state,

        error: null,
        requesting: false,

        id: blockId ?? 0,
        uid: uid ?? 0,
        isAdded: isActive,

        aspectRatio: aspectRatio ?? 'original',
        img: img ?? '',
        isFullWidth: isFullWidth ?? false,
        url: url ?? '',
        alt: alt ?? '',
        align: align ?? 'center',
      };
    })
    .addCase(imageActions.imageClear, () => ({ ...initialState }))

    .addCase(imageActions.imageUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(imageActions.imageUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(imageActions.imageUpdateStore, (state) => ({ ...state, error: false, requesting: false }))

    .addCase(imageActions.imageUpdateAspectRatio, (state, { payload: aspectRatio }) => ({ ...state, aspectRatio }))
    .addCase(imageActions.imageUpdateImg, (state, { payload: img }) => ({ ...state, img }))
    .addCase(imageActions.imageUpdateIsFullWidth, (state, { payload: isFullWidth }) => ({ ...state, isFullWidth }))
    .addCase(imageActions.imageUpdateUrl, (state, { payload: url }) => ({ ...state, url }))
    .addCase(imageActions.imageUpdateAlt, (state, { payload: alt }) => ({ ...state, alt }))
    .addCase(imageActions.imageUpdateAlign, (state, { payload: align }) => ({ ...state, align }));
});

export default image;
